var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSignOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0001 12C22.0001 17.5228 17.5229 22 12.0001 22C6.47721 22 2.00006 17.5228 2.00006 12C2.00006 6.47715 6.47721 2 12.0001 2C17.5229 2 22.0001 6.47715 22.0001 12ZM17.4568 18.5174C15.9804 19.7549 14.0772 20.5 12.0001 20.5C7.30564 20.5 3.50006 16.6944 3.50006 12C3.50006 9.92283 4.24514 8.01968 5.48262 6.54323L17.4568 18.5174ZM18.5175 17.4568L6.54328 5.48257C8.01973 4.24508 9.92288 3.5 12.0001 3.5C16.6945 3.5 20.5001 7.30558 20.5001 12C20.5001 14.0772 19.755 15.9803 18.5175 17.4568Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSignOutlined);
export default __webpack_public_path__ + "static/media/no-sign-outlined.e8d53011.svg";
export { ForwardRef as ReactComponent };